// Third Party Imports
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';
import {get, isEmpty} from 'lodash';

// Relative Imports
import appActions from '../../actions/actions';
import InformationPage from './InformationPage';
import informationPageAction from '../../actions/informationPage';
import helpActions from '../../actions/help';
import userInfoActions from '../../actions/userInfo';
import payoutDetailsActions from '../../actions/payoutDetails';

function mapStateToProps(state, ownProps) {
    return {
        appState: get(state, 'app.appState', ''),
        ineligibilityStatusCode: get(state, 'app.ineligibilityStatusCode') || get(state, 'informationPage.ineligibilityStatusCode', ''),
        ineligibilityStatus: ownProps.ineligibilityStatus || get(state, 'app.ineligibilityFormStatus', ''),
        publicUuid: get(state, 'app.publicUuid', ''),
        header1: get(state, 'informationPage.header_1', ''),
        header2: get(state, 'informationPage.header_2', ''),
        subHeading: get(state, 'informationPage.subHeading', ''),
        contents: get(state, 'informationPage.contents', []),
        phoneNumber: get(state, 'informationPage.phoneNumber', ''),
        email: get(state, 'informationPage.email', ''),
        help: get(state, 'informationPage.help', ''),
        isHelpIconHovered: get(state, 'informationPage.helpIconHoverStatus', false),
        isEmailIconHovered: get(state, 'informationPage.emailIconHoverStatus', false),
        userInfo: get(state, 'userInfoDetails.userInfoMetadata', ''),
        translations: state.app.translations,
        brandName: state.system.brandName,
        siteName: state.system.siteName,
        unsupportedPayoutCountryName: get(state, 'payoutDetails.unsupportedPayoutCountryName', ''),
        isPmis: get(state, 'pmisBusinessModelSwitch.isPmis', false)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        appActions: bindActionCreators(appActions, dispatch),
        informationPageAction: bindActionCreators(informationPageAction, dispatch),
        helpActions: bindActionCreators(helpActions, dispatch),
        userInfoActions: bindActionCreators(userInfoActions, dispatch),
        payoutDetailsActions: bindActionCreators(payoutDetailsActions, dispatch),
        dispatch
    };
}

@connect(mapStateToProps, mapDispatchToProps)
export default class InformationPageContainer extends React.Component {
    constructor(props) {
        super(props);
        this.triggerEdapPageViewAction = this.triggerEdapPageViewAction.bind(this);
        this.onEmailIconMouseHovered = this.onEmailIconMouseHovered.bind(this);
        this.onEmailIconMouseOut = this.onEmailIconMouseOut.bind(this);
        this.onHelpIconMouseHovered = this.onHelpIconMouseHovered.bind(this);
        this.onHelpIconMouseOut = this.onHelpIconMouseOut.bind(this);
        this.onHelpClick = this.onHelpClick.bind(this);
        this.onBackButtonClick = this.onBackButtonClick.bind(this);
    }

    componentDidMount() {
        const {messageKey, ineligibilityStatusCode, ineligibilityStatus, brandName, siteName} = this.props;
        this.props.appActions.enableLoadOverLay(true);
        const status = (ineligibilityStatus) ? ineligibilityStatus : this.getIneligibilityStatus();

        this.props.informationPageAction.populateInformationPageMessage(messageKey, status, brandName, siteName);
        if (messageKey === 'ACCESS_DENIED' || ineligibilityStatusCode) {
            this.props.userInfoActions.getUserInfo();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.appState === 'ADD_OWNER_ACCOUNT') {
            this.props.appActions.addOwnerAccount();
        } else if ((this.props.messageKey === 'ACCESS_DENIED' || this.props.ineligibilityStatusCode) && isEmpty(this.props.userInfo) && !isEmpty(nextProps.userInfo)) {
            this.sendIneligibleEmail(nextProps.userInfo);
        } else {
            this.props.appActions.enableLoadOverLay(false);
        }
    }

    sendIneligibleEmail(userInfo) {
        const data = userInfo
            ? {
                  firstName: userInfo.user.firstName,
                  lastName: userInfo.user.lastName,
                  emailAddress: userInfo.user.emailAddress,
                  companyName: '--',
                  phoneNumber: userInfo.user.contact.phone ? `+${userInfo.user.contact.phone.countryCode}-${userInfo.user.contact.phone.number}` : '--',
                  message: this.getIneligibilityStatus()
              }
            : {
                  message: this.getIneligibilityStatus()
              };
        const helpFormData = {
            data,
            type: 'INELIGIBLE'
        };

        this.props.helpActions.submitHelpForm(helpFormData);
    }

    getIneligibilityStatus() {
        const {ineligibilityStatusCode} = this.props;

        let code = {
            '720': 'INELIGIBLE_PPM',
            '725': 'MULTIPLE_ACCOUNT',
            '730': 'SERVICE_FEE_VIOLATOR',
            '735': 'NFMP_VIOLATOR',
            '740': 'NO_SOFTWARE_INELIGIBILTY',
            '745': 'DUPLICATE_PROJECT',
            '': 'ONBOARDING_STATUS_NOT_FOUND'
        } [ineligibilityStatusCode];

        if (typeof code === "undefined") {
            code = 'ONBOARDING_STATUS_NOT_FOUND'
        }
        return code
    }

    onEmailIconMouseHovered() {
        this.props.informationPageAction.emailIconMouseHovered(true);
    }

    onEmailIconMouseOut() {
        this.props.informationPageAction.emailIconMouseHovered(false);
    }

    onHelpIconMouseHovered() {
        this.props.informationPageAction.helpIconMouseHovered(true);
    }

    onHelpIconMouseOut() {
        this.props.informationPageAction.helpIconMouseHovered(false);
    }

    triggerEdapPageViewAction() {
        this.props.appActions.triggerEdapPageView(this.props.publicUuid, 'Information Page');
    }

    onHelpClick() {
        if ((this.props.messageKey === 'ACCESS_DENIED') || (this.props.messageKey === 'ERROR') || this.props.ineligibilityStatusCode) {
            this.props.helpActions.toggleHelpModal(true, 'helpModal');
        } else {
            this.props.helpActions.toggleHelpModal(true, 'inEligibleModal');
        }
        this.props.appActions.triggerEdapEvent('generic.click', {
            eventcategory: 'Help'
        }, {});
    }

    onBackButtonClick() {
        this.props.appActions.triggerEdapEvent('generic.click', {
            eventcategory: 'Back'
        }, {});
        switch (this.props.ineligibilityStatus) {
            case 'INVALID_PROPERTY_COUNT':
                this.props.appActions.changeAppState('PROPERTY_COUNT');
                break;
            case 'INVALID_VAT_NUMBER':
                this.props.appActions.changeAppState('VAT_INFORMATION');
                break;
            case 'NO_SOFTWARE_INELIGIBILTY':
            case 'UNSUPPORTED_AGENCY_TO_MOR_SWITCH':
                this.props.appActions.changeAppState('SOFTWARE_DETAILS');
                break;
            case 'UNSUPPORTED_PAYOUT_COUNTRY':
                this.props.appActions.changeAppState('PAYOUT_DETAILS');
                // reset data
                this.props.payoutDetailsActions.handleFieldValueChange('bankingCountry', '');
                this.props.payoutDetailsActions.setUnsupportedPayoutCountry('');
                this.props.payoutDetailsActions.toggleContinueButton();
                break;
            default:
                this.props.appActions.changeAppState('COMPANY_LOCATION');
        }
    }

    render() {
        const toRender = (this.props.appState === 'ADD_OWNER_ACCOUNT')
            ? null
            : (
                <InformationPage publicUuid={this.props.publicUuid}
                    translations={this.props.translations}
                    triggerEdapPageViewAction={this.triggerEdapPageViewAction}
                    header1={this.props.header1}
                    header2={this.props.header2}
                    subHeading={this.props.subHeading}
                    contents={this.props.contents}
                    phoneNumber={this.props.phoneNumber}
                    email={this.props.email}
                    help={this.props.help}
                    toggleEmailIcon={this.toggleEmailIcon}
                    onEmailIconMouseHovered={this.onEmailIconMouseHovered}
                    onEmailIconMouseOut={this.onEmailIconMouseOut}
                    onHelpIconMouseHovered={this.onHelpIconMouseHovered}
                    onHelpIconMouseOut={this.onHelpIconMouseOut}
                    isHelpIconHovered={this.props.isHelpIconHovered}
                    isEmailIconHovered={this.props.isEmailIconHovered}
                    onHelpClick={this.onHelpClick}
                    onBackButtonClick={this.onBackButtonClick}
                    messageKey={this.props.messageKey}
                    ineligibilityStatusCode={this.props.ineligibilityStatusCode}
                    brandName={this.props.brandName}
                    ineligibilityStatus={this.props.ineligibilityStatus}
                    unsupportedPayoutCountryName={this.props.unsupportedPayoutCountryName}
                    isPmis={this.props.isPmis}
                />
            );
        return toRender;
    }
}

InformationPageContainer.propTypes = {
    publicUuid: PropTypes.string,
    translations: PropTypes.any, // eslint-disable-line react/forbid-prop-types
    buttonLabel: PropTypes.string,
    heading: PropTypes.string,
    contents: PropTypes.array, // eslint-disable-line react/forbid-prop-types
    dialogHeading: PropTypes.string,
    dialogFooter: PropTypes.string,
    ineligibilityStatusCode: PropTypes.string
};
InformationPageContainer.defaultProps = {
    publicUuid: '-1',
    buttonLabel: '',
    heading: '',
    contents: [],
    dialogHeading: '',
    dialogFooter: '',
    ineligibilityStatusCode: ''
};
